import { ListData } from '@fi-app/components/items-list/list-data.service';
import { Injector } from '@angular/core';
import {
    ItemsListElementType,
    ItemsListHeader,
    ItemsListHeaderProperties,
} from '@fi-app/components/items-list/items-list-header';
import { ObjectTypes } from '@fi-shared/types';
import { IFormReportInactiveColleague } from '../fi-form-report';
import { UserListProfileIconColumnComponent } from '@fi-app/user/user-list/user-list-profile-icon-column/user-list-profile-icon-column.component';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';

export class FormReportInactiveColleaguesListData extends ListData<IFormReportInactiveColleague> {
    constructor(injector: Injector) {
        super(injector, true);

        this.ShowDelete = false;
        this.CanShowLoadMore = false;
        this.ObjectType = ObjectTypes.Form;
        this.ChildProperty = 'AnswerSets';

        this.Header.push(
            new ItemsListHeader(
                '',
                '',
                new ItemsListHeaderProperties(
                    'CcmListItem-Icon CcmListItem-NoBorder',
                    true,
                    UserListProfileIconColumnComponent,
                ),
            ),
        );

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('colleague'),
                'FullName',
                new ItemsListHeaderProperties(
                    'CcmListItem-Name CcmListItem-NoBorder',
                    true,
                    ItemsListElementType.SpanPlain,
                ),
            ),
        );

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('common.area'),
                'AreaName',
                new ItemsListHeaderProperties(
                    'CcmListItem-NoBorder CcmList-Column-ShowAlways',
                    true,
                    ItemsListElementType.SpanPlain,
                    { isRightAligned: true },
                ),
            ),
        );

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('common.unit'),
                'BusinessUnitName',
                new ItemsListHeaderProperties(
                    'CcmListItem-NoBorder CcmList-Column-ShowAlways',
                    true,
                    ItemsListElementType.SpanPlain,
                    { isRightAligned: true },
                ),
            ),
        );

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('common.last_reminder'),
                'LastReminderSent',
                new ItemsListHeaderProperties(
                    'CcmList-Column-Narrow CcmListItem-NoBorder',
                    false,
                    ItemsListElementType.SpanPlain,
                    { isRightAligned: true },
                ),
                null,
                null,
                (data) => {
                    return injector.get(FiFormatDateService).formatDate(data.LastReminderSent, 'date');
                },
            ),
        );
    }

    updateReminderSentContent() {
        this.Header[this.Header.length - 1].Properties.updateContent$.next();
    }
}
